(function () {
  'use strict';

  /* ---------------------------------------------------------------------
   * 1. Hat artwork (verbatim path data from hat-base.svg / hat-top.svg,
   *    native 0-800 viewBox units). Base = single silhouette used both as
   *    the merged base-layer silhouette and as the occluder for letter 0.
   *    Top = the 3 decorative red pieces, cut as their own separate layer.
   * ------------------------------------------------------------------- */
  const HAT_BASE_D = "M329.098,405.295c0.94-6.084,4.435-10.639,10.386-13.538c1.531-0.746,3.152-1.332,4.721-1.899l0.403-0.146 c0.47-0.17,0.732-0.288,0.658-0.727l0.195-0.06c-0.106-1.056,0.242-2.011,0.774-2.893c1.134-1.884,2.175-3.808,2.991-5.855 c1.251-3.139,2.724-6.166,4.631-8.97c1.385-2.036,2.983-3.905,4.513-5.827c2.651-3.331,5.632-6.326,9.009-8.924 c3.413-2.626,7.153-4.737,10.83-6.954c5.571-3.359,11.636-5.013,18.076-5.477c5.582-0.402,11.137,0.063,16.687,0.548 c4.736,0.414,9.165,1.818,13.191,4.404c2.578,1.656,5.019,3.502,7.374,5.451c4.451,3.684,8.332,7.929,11.978,12.399 c0.821,1.006,1.572,2.064,2.316,3.132l0.275-0.038c2.834-0.057,5.192,0.338,7.407,1.25l0.128,0.052l-0.03,0.134 c-0.082,0.369-0.252,0.661-0.456,0.919c-0.324,0.456-0.777,0.798-1.109,1.203c-0.109,0.15-0.202,0.308-0.253,0.486 c0.206,0.217,0.437,0.229,0.7,0.242l0.119,0.007c3.146,0.213,5.937,0.914,8.534,2.146c2.236,1.061,3.771,2.299,4.833,3.896 c1.109,1.669,1.451,3.146,1.076,4.651c-0.189,0.755-0.008,1.264,0.344,1.839c1.822,2.973,2.14,6.005,0.945,9.012 c-0.327,0.824-0.713,1.658-1.245,2.358c-0.093,0.13-0.194,0.252-0.297,0.37c-0.017,0.019-0.034,0.038-0.051,0.056 c-0.719,0.798-1.685,1.325-3.125,1.275c-0.02,0.027-0.044,0.054-0.067,0.08c-0.056,0.066-0.113,0.131-0.141,0.198 c-0.358,0.843-0.801,1.601-1.295,2.291c-0.006,0.008-0.01,0.016-0.016,0.024c-0.06,0.084-0.126,0.16-0.188,0.242 c-1.374,1.857-3.211,3.272-5.226,4.501c-1.566,0.955-3.265,1.554-5.154,1.228c-0.478-0.082-0.737,0.209-0.986,0.506 c-0.902,1.076-1.968,1.963-3.172,2.663c-2.208,1.285-4.591,1.868-7.081,1.117c-1.259-0.379-2.269-0.501-3.512,0.184 c-1.925,1.062-4.109,1.539-6.246,2.055c-4.117,0.994-7.825,2.784-11.06,5.535c-2.335,1.986-4.505,4.145-6.645,6.335 c-0.779,0.797-1.609,1.546-2.29,2.426c-0.062,0.082-0.13,0.159-0.189,0.243c-0.009,0.012-0.015,0.027-0.024,0.039 c-0.171,0.251-0.329,0.512-0.464,0.79c-1.16,2.371-2.44,4.483-3.882,6.403c-0.491,0.66-1.006,1.305-1.547,1.932 c-1.867,2.165-3.951,4.035-6.662,5.094c-0.244,0.095-0.428,0.271-0.593,0.491c-0.822,1.098-1.711,2.079-2.661,2.956 c-0.012,0.011-0.025,0.022-0.038,0.033c-0.46,0.422-0.936,0.815-1.427,1.183c-0.033,0.024-0.066,0.047-0.099,0.071 c-0.301,0.222-0.597,0.45-0.91,0.651l-0.184,0.07c-1.765,1.095-3.673,1.831-5.753,2.193l-0.243,0.093 c-0.484,0.077-0.976,0.142-1.483,0.18c-0.34,0.026-0.724-0.014-1.03,0.241c0.029,0.144,0.07,0.287,0.116,0.439 c0.119,0.396,0.242,0.806,0.126,1.259c-0.086,0.337-0.232,0.61-0.412,0.845c-0.005,0.007-0.011,0.012-0.015,0.019 c-0.085,0.108-0.177,0.207-0.277,0.297c-0.386,0.383-0.883,0.642-1.41,0.842c-2.007,0.763-4.064,0.688-6.095,0.117 c-0.942-0.265-1.804-0.637-2.608-1.084c-1.971-1.067-3.702-2.692-5.236-4.937c-0.042-0.061-0.079-0.129-0.115-0.198 c-0.069-0.13-0.137-0.217-0.222-0.282c-0.046-0.017-0.084-0.041-0.143-0.048c-0.184,0.252-0.296,0.543-0.41,0.853 c-0.072,0.197-0.148,0.4-0.245,0.594c-0.104,0.208-0.226,0.387-0.356,0.548c-0.562,0.771-1.367,0.977-2.116,0.584 c-0.314-0.139-0.615-0.366-0.883-0.682c-0.292-0.344-0.524-0.662-0.71-0.972c-1.972-3.298-2.914-6.956-2.799-10.87 c0.005-0.169,0.02-0.339,0.035-0.509c0.032-0.361,0.055-0.704-0.009-1.042c-0.287,0.029-0.471,0.242-0.686,0.374 c-0.44,0.271-0.82,0.246-1.159,0.007c-0.161-0.086-0.318-0.201-0.467-0.373c-0.286-0.331-0.448-0.749-0.51-1.315 c-0.127-1.179,0.059-2.375,0.588-3.764c0.961-2.528,2.411-4.863,4.308-6.937c0.054-0.059,0.113-0.116,0.173-0.175 c0.272-0.264,0.432-0.444,0.359-0.723c-0.194-0.741-0.412-1.477-0.642-2.257c-0.07-0.237-0.141-0.479-0.214-0.726 c-0.76,0.661-1.43,1.282-2.144,1.836c-2.707,2.101-5.525,3.978-9.04,4.461c-2.287,0.314-4.475,0.106-6.569-0.946 c-0.033-0.017-0.064-0.036-0.096-0.053c-0.008-0.004-0.016-0.007-0.023-0.011c-0.153-0.077-0.299-0.166-0.448-0.251 c-0.047-0.027-0.096-0.052-0.143-0.08c-0.327-0.192-0.647-0.391-0.956-0.591c-0.345-0.223-0.7-0.45-1.059-0.655 c-0.131,0.066-0.214,0.14-0.281,0.218c-0.039,0.075-0.066,0.155-0.093,0.244l-0.024,0.079c-0.071,0.223-0.178,0.399-0.303,0.55 c-0.274,0.411-0.708,0.566-1.268,0.487c-0.415-0.058-0.81-0.186-1.188-0.386c-0.021-0.011-0.038-0.027-0.059-0.038 c-0.021-0.01-0.043-0.016-0.063-0.027c-1.642-0.871-2.99-2.207-4.241-4.204c-0.415-0.662-0.708-1.393-0.993-2.1 c-0.467-1.161-0.908-2.259-1.847-3.126c-0.522-0.482-0.837-1.145-1.143-1.787c-0.108-0.228-0.216-0.455-0.333-0.673 C329.253,411.416,328.627,408.339,329.098,405.295z";
  const HAT_TOP_DS = ["M445.71,370.475c-1.437,0.369-2.814,1.012-4.147,1.634c-1.473,0.688-2.994,1.398-4.643,1.771 c-0.02-0.734-0.072-1.48-0.501-2.125c-0.276-0.415-0.597-0.657-0.952-0.719c-0.325-0.057-0.667,0.041-1.009,0.294 c-1.08,0.797-2.326,1.141-3.401,1.372c-0.85,0.183-1.734,0.244-2.589,0.304c-0.683,0.047-1.39,0.096-2.082,0.207 c-0.185,0.03-0.366,0.083-0.54,0.135c-0.313,0.093-0.609,0.18-0.906,0.13c-0.356-0.75-0.614-1.15-0.999-1.249 c-0.401-0.102-0.845,0.15-1.573,0.684c-0.991,0.726-1.969,1.322-2.989,1.821c-0.475,0.233-0.953,0.458-1.432,0.683 c-1.678,0.79-3.413,1.606-4.954,2.735c-0.195,0.142-0.341,0.229-0.53,0.153c-0.086-0.17-0.072-0.361-0.057-0.58 c0.012-0.174,0.025-0.354-0.015-0.537c-0.022-0.099-0.033-0.204-0.044-0.308c-0.04-0.364-0.09-0.817-0.578-1.038 c-0.53-0.239-0.918,0.069-1.23,0.316c-0.062,0.049-0.123,0.098-0.186,0.143c-0.751,0.539-1.425,1.18-2.077,1.801 c-0.69,0.656-1.403,1.334-2.201,1.883c-2.527,1.737-4.298,4.179-5.264,7.258c-0.15,0.476-0.377,0.813-0.714,1.058 c-0.161,0.117-0.321,0.236-0.481,0.355c-0.461,0.342-0.937,0.696-1.431,0.993c-2.113,1.268-4.442,2.136-6.646,2.916 c-3.054,1.081-5.907,2.747-8.479,4.951c-1.222,1.048-1.288,1.359-0.504,2.684c-0.029,0.222-0.171,0.4-0.32,0.588l-0.072,0.092 c-0.188,0.242-0.379,0.483-0.57,0.723c-0.422,0.531-0.858,1.08-1.255,1.646c-2.873,4.106-5.88,7.325-9.196,9.841 c-3.146,2.387-5.216,4.991-6.329,7.962c-0.017,0.046-0.063,0.099-0.115,0.16c-0.001,0.001-0.003,0.003-0.004,0.005 c-0.05-0.033-0.089-0.059-0.108-0.085c-0.321-0.423-1.258-1.838-1.189-2.33c0.075-0.532,0.387-1.028,0.88-1.397 c1.539-1.154,2.537-2.315,3.142-3.655c1.327-2.941,2.152-5.13,0.867-8.342c-0.351-0.874-0.776-1.742-1.232-2.515 c0.065-0.166,0.144-0.21,0.249-0.269c1.453-0.835,1.642-1.451,0.911-2.887c-0.193-0.38-0.455-0.773-0.8-1.2 c-0.215-0.267-0.449-0.523-0.675-0.77c-0.212-0.231-0.424-0.463-0.622-0.705c-0.801-0.979-0.737-1.795,0.21-2.646 c0.495-0.445,1.073-0.805,1.631-1.153l0.345-0.216c4.031-2.553,8.335-4.576,12.791-6.016l0.125-0.039 c0.349-0.108,0.743-0.23,0.994-0.634l0.179-0.288l-0.337,0.039c-4.222,0.492-9.634,1.478-14.339,4.739 c1.019-3.228,3.194-5.713,5.525-8.177c2.306-2.438,4.867-4.943,7.968-6.752c2.888-1.684,5.993-3.413,9.416-4.429l0.156-0.046 l-0.045-0.156c-0.13-0.452-0.422-0.512-0.616-0.551l-0.04-0.009c-0.935-0.2-1.898-0.229-2.867-0.084 c-1.988,0.296-3.695,1.188-5.645,2.437c-4.116,2.634-7.574,5.897-10.413,8.742c-4.013,4.018-6.478,7.894-7.761,12.198 c-0.09,0.303-0.171,0.571-0.504,0.793c-0.066-0.028-0.158-0.068-0.252-0.106l-1.085-0.446c-1.284-0.528-2.568-1.057-3.853-1.583 c-0.54-0.221-0.946-0.601-1.208-1.129c-1.546-3.122-6.275-4.291-9.061-3.059l-0.091,0.042l-2.31,0.708l0.195-0.06 c-0.106-1.056,0.242-2.011,0.774-2.893c1.134-1.884,2.175-3.808,2.991-5.855c1.251-3.139,2.724-6.166,4.631-8.97 c1.385-2.036,2.983-3.905,4.513-5.827c2.651-3.331,5.632-6.326,9.009-8.924c3.413-2.626,7.153-4.737,10.83-6.954 c5.571-3.359,11.636-5.013,18.076-5.477c5.582-0.402,11.137,0.063,16.687,0.548c4.736,0.414,9.165,1.818,13.191,4.404 c2.578,1.656,5.019,3.502,7.374,5.451c4.451,3.684,8.332,7.929,11.978,12.399c0.821,1.006,1.572,2.064,2.316,3.132L445.71,370.475z", "M364.451,433.172l-0.138,0.068c-0.856,0.422-1.502,1.049-2.187,1.713c-0.402,0.39-0.816,0.792-1.28,1.151 c-0.235-1.351-0.329-2.763,0.317-4.053c1.59-3.175,3.478-5.719,5.765-7.775c1.629-1.463,3.329-3.074,4.722-4.949 c0.016-0.02,0.035-0.04,0.054-0.06c0.095-0.101,0.297-0.311,0.043-0.644l-0.101-0.132l-5.148,4.041 c-0.106-0.296-0.038-0.534,0.032-0.784l0.028-0.1c0.242-0.898,0.641-1.763,1.219-2.644c1.544-2.353,3.737-4.119,5.858-5.827 l0.65-0.525c2.02-1.637,4.579-3.895,6.463-6.851l0.151-0.237c0.947-1.486,1.927-3.022,2.705-4.645 c0.284-0.593,0.649-0.782,1.253-0.651l0.084,0.019c0.404,0.09,4.192,1.278,4.669,0.977l-0.379-0.175l-1.876-1.039 c-0.867-0.173-1.695-0.743-2.11-0.873c-0.374-0.116-0.699-0.218-0.833-0.559c0.033-0.34,0.252-0.549,0.514-0.767 c1.946-1.622,4.11-2.945,6.431-3.932c0.789-0.335,1.609-0.64,2.401-0.934c1.356-0.504,2.758-1.025,4.069-1.723 c1.953-1.04,3.943-2.254,4.937-4.639c0.204-0.488,0.563-0.937,0.909-1.37c0.106-0.131,0.21-0.262,0.311-0.394 c1.082-1.419,2.445-2.604,3.763-3.749c0.696-0.605,1.417-1.231,2.09-1.886c0.116-0.114,0.225-0.24,0.334-0.367 c0.232-0.27,0.452-0.527,0.758-0.664c0.094,0.121,0.079,0.249,0.046,0.443c-0.011,0.062-0.021,0.124-0.026,0.185 c-0.021,0.244-0.044,0.488-0.067,0.732c-0.041,0.433-0.082,0.867-0.111,1.301c-0.038,0.561,0.171,0.899,0.623,1.007l0.043,0.01 l0.043-0.013c0.484-0.148,0.528-0.541,0.563-0.856l0.005-0.041c0.049-0.428,0.271-0.717,0.72-0.937 c2.688-1.317,5.334-2.814,7.892-4.261c0.52-0.295,1.041-0.59,1.563-0.883c0.048-0.027,0.096-0.057,0.145-0.088 c0.176-0.111,0.327-0.209,0.552-0.185c0.037,0.708-0.299,1.306-0.654,1.937c-0.344,0.612-0.7,1.245-0.697,1.995l0.001,0.297 l0.251-0.159c0.47-0.297,0.831-0.746,1.042-1.297c0.691-1.801,2.128-2.26,4.075-2.396c0.08-0.005,0.159-0.007,0.238-0.009 c0.077-0.001,0.154-0.003,0.231-0.008c0.245-0.015,0.489-0.029,0.734-0.043c2.245-0.128,4.566-0.26,6.632-1.513 c0.031-0.019,0.093-0.056,0.257,0.045c0.069,0.654-0.286,1.198-0.661,1.772c-0.327,0.499-0.664,1.016-0.757,1.646l-0.027,0.182 l0.184,0.005c1.062,0.033,1.53-0.653,1.94-1.257c0.271-0.399,0.564-0.594,1.013-0.671c1.777-0.307,3.79-0.655,5.591-1.659 c3.558-1.985,7.347-1.898,10.587-1.552l0.063,0.006c0.249,0.024,0.45,0.044,0.6,0.317l-3.567,2.922l0.102,0.127 c0.017,0.021,0.031,0.042,0.043,0.06c0.038,0.056,0.09,0.133,0.189,0.142c0.338,0.033,0.677,0.057,1.016,0.081 c2.721,0.19,5.805,0.406,8.682,1.404c3.104,1.077,5.259,2.878,6.588,5.507l0.075,0.148c0.274,0.532,0.555,1.082,0.435,1.672 c-0.268,0.087-0.401-0.045-0.582-0.223c-0.037-0.037-0.075-0.074-0.113-0.108c-0.846-0.761-1.638-1.26-2.489-1.572 c-0.037-0.013-0.075-0.03-0.113-0.046c-0.221-0.096-0.555-0.24-0.853,0.126l-0.056,0.068l0.026,0.084 c0.116,0.381,0.396,0.624,0.642,0.838c0.066,0.058,0.132,0.115,0.195,0.175c0.999,0.955,1.772,1.76,2.433,2.535 c1.489,1.745,2.357,3.545,2.653,5.501c0.377,2.488-0.507,4.637-2.701,6.57c-0.11,0.097-0.19,0.139-0.307,0.111 c-0.035-0.226-0.067-0.454-0.1-0.682c-0.203-1.419-0.412-2.886-1.111-4.244l-0.246-0.479l-0.062,0.535 c-0.073,0.627-0.078,1.254-0.084,1.86c-0.002,0.206-0.004,0.413-0.008,0.619c-0.058,2.713-0.64,4.611-1.886,6.157 c-1.45,1.796-3.111,3.259-4.939,4.349c-1.037,0.618-2.194,0.983-3.087,1.231l-0.08,0.023c-0.328,0.095-0.541,0.138-0.716-0.054 c-0.128-0.141-0.086-0.272,0.008-0.509c0.03-0.076,0.059-0.15,0.079-0.224c0.034-0.127,0.079-0.252,0.124-0.377 c0.043-0.121,0.086-0.242,0.121-0.365c0.288-1.011,0.368-1.905,0.25-2.816l-0.028-0.217l-0.2,0.088 c-0.591,0.258-0.755,0.737-0.887,1.121l-0.022,0.065c-0.309,0.888-0.728,1.778-1.321,2.802c-2.114,3.653-5.153,5.028-9.276,4.211 l-0.112-0.021c-0.285-0.051-0.534-0.096-0.736-0.419c0.997-1.209,2-2.458,2.269-4.129l-0.296-0.12 c-1.014,1.444-2.089,2.581-3.286,3.474c-2.987,2.228-6.408,3.231-10.248,4.224c-4.469,1.156-8.04,2.94-10.916,5.455 c-1.843,1.613-3.527,3.451-4.96,5.048l-0.765,0.856c-2.124,2.38-4.319,4.842-7.012,6.702c-0.055,0.038-0.112,0.075-0.17,0.112 c-0.25,0.161-0.534,0.345-0.733,0.678l-0.213,0.358l0.4-0.117c0.688-0.201,1.286-0.574,1.863-0.935 c0.377-0.236,0.764-0.478,1.177-0.672c-0.011,0.434-0.027,0.467-0.196,0.802c-1.432,2.851-3.396,5.348-5.836,7.421 c-1.791,1.522-3.435,2.359-5.173,2.635c-2.039,0.324-3.734,0.476-5.282,0.469c-0.069,0-0.139-0.002-0.209-0.005 c-0.377-0.013-0.8-0.029-1.203,0.302l-0.188,0.155l0.214,0.116c1.539,0.833,3.172,0.844,4.751,0.855 c0.439,0.004,0.891,0.007,1.331,0.028c-0.013,0.153-0.095,0.227-0.201,0.322l-0.035,0.032c-1.018,0.933-2.385,2.127-3.922,3.081 c-2.437,1.512-4.819,2.116-7.279,1.847c-1.099-0.12-2.213-0.269-3.29-0.413c-0.458-0.061-0.916-0.122-1.374-0.181 c-0.094-0.012-0.19-0.03-0.287-0.048c-0.19-0.035-0.392-0.073-0.602-0.073c-0.241,0-0.494,0.05-0.751,0.212l-0.118,0.074 l0.054,0.128c0.202,0.476,0.587,0.652,0.926,0.807c0.065,0.03,0.129,0.059,0.192,0.091c0.256,0.128,0.526,0.212,0.788,0.293 c0.337,0.104,0.655,0.203,0.942,0.388c0.783,0.505,1.392,1.664,1.231,2.34c-0.191,0.798-0.737,1.23-1.828,1.448 c-0.763,0.152-1.388,0.173-1.965,0.065c-2.462-0.458-4.442-1.41-6.052-2.911c-1.236-1.153-2.349-2.598-3.503-4.548 c-0.07-0.118-0.136-0.238-0.202-0.359c-0.231-0.42-0.47-0.855-0.876-1.219l-0.17-0.153l-0.09,0.21 c-0.129,0.302-0.075,0.579-0.027,0.823c0.042,0.211,0.075,0.378-0.007,0.527c-0.451,0.828-0.957,1.69-1.73,2.322 c-0.56,0.456-1.082,0.399-1.551-0.175c-0.361-0.442-0.648-0.954-0.851-1.52c-0.971-2.712-1.513-5.588-1.61-8.55 c-0.059-1.76,0.017-3.757,1.66-5.196c0.351-0.308,0.42-0.695,0.194-1.091L364.451,433.172z", "M330.869,404.644c1.62-6.167,5.195-10.02,10.624-11.452c2.257-0.595,4.119-1.148,5.832-2.372 c0.068-0.049,0.152-0.086,0.247-0.125c3.182-1.321,6.003-0.56,7.55,2.037c0.271,0.456,0.686,0.71,1.054,0.912 c0.909,0.5,1.882,0.878,2.823,1.244c0.786,0.306,1.598,0.622,2.361,1.004c1.947,0.976,3.938,2.141,5.315,4.031 c0.348,0.478,0.345,0.784-0.011,1.093c-0.415,0.361-0.769,0.36-1.181,0.002c-0.587-0.512-1.094-0.809-1.641-0.964l-0.563-0.159 l0.399,0.429c2.358,2.535,3.322,4.467,3.499,7.648c0.184,3.29-1.145,5.821-3.068,7.666c-0.581,0.558-1.098,1.19-1.675,2.051 c-1.704,2.54-2.988,5.496-5.403,6.949c-2.924,1.759-5.472,2.388-8.017,1.981c-1.679-0.268-3.242-0.902-4.577-1.475 c-0.511-0.219-0.906-0.366-1.223-0.484c-1.055-0.391-1.055-0.391-1.18-1.807c-0.024-0.264-0.051-0.574-0.089-0.94l-0.014-0.136 c-0.052-0.532-0.03-2.007-0.203-3.048l-0.308-3.547l-0.925,2.159c-0.229,0.219,0.417,3.369,0.412,3.549l-0.003,0.084 c-0.032,0.556-0.016,1.119-0.001,1.662c0.022,0.761,0.044,1.549-0.068,2.316c-0.05,0.346-0.154,0.569-0.31,0.661 c-0.145,0.085-0.358,0.076-0.64-0.027c-0.494-0.182-0.957-0.499-1.417-0.971c-1.994-2.049-2.958-4.62-3.574-6.632 c-0.255-0.832-0.216-1.471,0.125-2.069l0.581-2.853l-1.012,2.074c-0.095,0.106-0.188,0.21-0.272,0.321 c-0.512,0.671-0.855,0.96-1.114,0.94c-0.257-0.022-0.543-0.358-0.929-1.09C330.412,411.773,329.94,408.185,330.869,404.644z"];
  const HAT_TOP_FILL = '#ED1C24';

  /* ---------------------------------------------------------------------
   * 2. Minimal SVG path `d` parser -> command objects {type,x,y,x1,y1,x2,y2}
   *    Supports M/m L/l C/c Z/z (incl. shorthand repeats), which is all
   *    these two source files use.
   * ------------------------------------------------------------------- */
  function parseSvgPath(d) {
    const tokens = d.match(/[MLCZmlcz]|-?\d*\.?\d+(?:e[-+]?\d+)?/g) || [];
    let i = 0, cx = 0, cy = 0, startX = 0, startY = 0, lastCmd = null;
    const cmds = [];
    const num = () => parseFloat(tokens[i++]);
    const isCmd = (t) => /^[MLCZmlcz]$/.test(t);
    while (i < tokens.length) {
      let cmd;
      if (isCmd(tokens[i])) { cmd = tokens[i]; i++; } else { cmd = lastCmd; }
      if (!cmd) break;
      const rel = cmd === cmd.toLowerCase();
      const C = cmd.toUpperCase();
      if (C === 'M') {
        const x = num(), y = num();
        cx = rel ? cx + x : x; cy = rel ? cy + y : y;
        startX = cx; startY = cy;
        cmds.push({ type: 'M', x: cx, y: cy });
        lastCmd = rel ? 'l' : 'L';
      } else if (C === 'L') {
        const x = num(), y = num();
        cx = rel ? cx + x : x; cy = rel ? cy + y : y;
        cmds.push({ type: 'L', x: cx, y: cy });
        lastCmd = cmd;
      } else if (C === 'C') {
        const x1 = num(), y1 = num(), x2 = num(), y2 = num(), x = num(), y = num();
        const ax1 = rel ? cx + x1 : x1, ay1 = rel ? cy + y1 : y1;
        const ax2 = rel ? cx + x2 : x2, ay2 = rel ? cy + y2 : y2;
        const ax = rel ? cx + x : x, ay = rel ? cy + y : y;
        cmds.push({ type: 'C', x1: ax1, y1: ay1, x2: ax2, y2: ay2, x: ax, y: ay });
        cx = ax; cy = ay;
        lastCmd = cmd;
      } else if (C === 'Z') {
        cmds.push({ type: 'Z' });
        cx = startX; cy = startY;
        lastCmd = null;
      } else { break; }
    }
    return cmds;
  }

  function bboxOfCmds(cmds) {
    let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
    for (const c of cmds) {
      const pts = [];
      if (c.type === 'M' || c.type === 'L') pts.push([c.x, c.y]);
      if (c.type === 'C') pts.push([c.x1, c.y1], [c.x2, c.y2], [c.x, c.y]);
      for (const p of pts) { if (p[0] < minX) minX = p[0]; if (p[0] > maxX) maxX = p[0]; if (p[1] < minY) minY = p[1]; if (p[1] > maxY) maxY = p[1]; }
    }
    const b = { minX: minX, minY: minY, maxX: maxX, maxY: maxY };
    b.width = b.maxX - b.minX; b.height = b.maxY - b.minY;
    return b;
  }

  const HAT_BASE_CMDS = parseSvgPath(HAT_BASE_D);
  const HAT_TOP_CMDS = HAT_TOP_DS.map(parseSvgPath);
  const HAT_BBOX = bboxOfCmds(HAT_BASE_CMDS);

  /* ---------------------------------------------------------------------
   * 3. Geometry engine: bezier/quadratic flattening, ClipperLib union /
   *    offset / weld, winding-number point-in-area, the occlusion clip,
   *    and RDP + Catmull-Rom smoothing for the score lines.
   * ------------------------------------------------------------------- */
  const CS = 100; // ClipperLib integer scale
  const FLATTEN_TOL = 0.35;

  function toCP(pts) { return pts.map(function (p) { return { X: Math.round(p[0] * CS), Y: Math.round(p[1] * CS) }; }); }
  function fromCP(path) { return path.map(function (p) { return [p.X / CS, p.Y / CS]; }); }

  function hasClipper() {
    try { return typeof ClipperLib !== 'undefined' && typeof ClipperLib.Clipper === 'function'; }
    catch (e) { return false; }
  }

  function clipperUnion(contourSets) {
    if (!hasClipper()) return [];
    const subject = [];
    for (const contours of contourSets) for (const c of contours) if (c.length >= 3) subject.push(toCP(c));
    if (!subject.length) return [];
    const cpr = new ClipperLib.Clipper();
    const simplified = ClipperLib.Clipper.SimplifyPolygons(subject, ClipperLib.PolyFillType.pftNonZero);
    cpr.AddPaths(simplified, ClipperLib.PolyType.ptSubject, true);
    const sol = new ClipperLib.Paths();
    cpr.Execute(ClipperLib.ClipType.ctUnion, sol, ClipperLib.PolyFillType.pftNonZero, ClipperLib.PolyFillType.pftNonZero);
    return ClipperLib.Clipper.CleanPolygons(sol, 0.02 * CS).map(fromCP);
  }

  function _splitCubic(x0, y0, x1, y1, x2, y2, x3, y3, tol, pts) {
    const dx = x3 - x0, dy = y3 - y0, l2 = dx * dx + dy * dy;
    if (l2 < 0.001) { pts.push([x3, y3]); return; }
    const d1 = Math.abs((x1 - x0) * dy - (y1 - y0) * dx);
    const d2 = Math.abs((x2 - x0) * dy - (y2 - y0) * dx);
    if ((d1 + d2) * (d1 + d2) <= tol * tol * 4 * l2) { pts.push([x3, y3]); return; }
    const ax = (x0 + x1) / 2, ay = (y0 + y1) / 2, bx = (x1 + x2) / 2, by = (y1 + y2) / 2, cx2 = (x2 + x3) / 2, cy2 = (y2 + y3) / 2;
    const dx2 = (ax + bx) / 2, dy2 = (ay + by) / 2, ex = (bx + cx2) / 2, ey = (by + cy2) / 2, mx = (dx2 + ex) / 2, my = (dy2 + ey) / 2;
    _splitCubic(x0, y0, ax, ay, dx2, dy2, mx, my, tol, pts);
    _splitCubic(mx, my, ex, ey, cx2, cy2, x3, y3, tol, pts);
  }
  function _splitQuadratic(x0, y0, qx, qy, x3, y3, tol, pts) {
    const x1 = x0 + (2 / 3) * (qx - x0), y1 = y0 + (2 / 3) * (qy - y0);
    const x2 = x3 + (2 / 3) * (qx - x3), y2 = y3 + (2 / 3) * (qy - y3);
    _splitCubic(x0, y0, x1, y1, x2, y2, x3, y3, tol, pts);
  }
  // Supports M/L/C (cubic, used by the hat SVGs) and Q (quadratic, used by
  // TrueType font glyphs like Atma) -- fonts only ever emit Q, never C.
  function flattenCmds(cmds, tol) {
    const out = []; let cur = null, px = 0, py = 0;
    for (const c of cmds) {
      if (c.type === 'M') { if (cur && cur.length > 1) out.push(cur); cur = [[c.x, c.y]]; px = c.x; py = c.y; }
      else if (c.type === 'L') { if (cur) cur.push([c.x, c.y]); px = c.x; py = c.y; }
      else if (c.type === 'C') { if (cur) _splitCubic(px, py, c.x1, c.y1, c.x2, c.y2, c.x, c.y, tol, cur); px = c.x; py = c.y; }
      else if (c.type === 'Q') { if (cur) _splitQuadratic(px, py, c.x1, c.y1, c.x, c.y, tol, cur); px = c.x; py = c.y; }
      else if (c.type === 'Z') { if (cur && cur.length > 1) out.push(cur); cur = null; }
    }
    if (cur && cur.length > 1) out.push(cur);
    return out;
  }

  function isLeft(a, b, pt) { return (b[0] - a[0]) * (pt[1] - a[1]) - (pt[0] - a[0]) * (b[1] - a[1]); }
  function windingNumber(pt, poly) {
    let wn = 0; const n = poly.length;
    for (let i = 0; i < n; i++) {
      const a = poly[i], b = poly[(i + 1) % n];
      if (a[1] <= pt[1]) { if (b[1] > pt[1] && isLeft(a, b, pt) > 0) wn++; }
      else { if (b[1] <= pt[1] && isLeft(a, b, pt) < 0) wn--; }
    }
    return wn;
  }
  function ptInArea(pt, area) { if (!area || !area.length) return false; let wn = 0; for (const p of area) wn += windingNumber(pt, p); return wn !== 0; }
  function findCrossing(pIn, pOut, area) {
    let a = 0, b = 1;
    for (let i = 0; i < 14; i++) {
      const t = (a + b) / 2;
      const pm = [pIn[0] + (pOut[0] - pIn[0]) * t, pIn[1] + (pOut[1] - pIn[1]) * t];
      if (ptInArea(pm, area)) a = t; else b = t;
    }
    const t = (a + b) / 2;
    return [pIn[0] + (pOut[0] - pIn[0]) * t, pIn[1] + (pOut[1] - pIn[1]) * t];
  }
  function clipContourOutsideArea(contour, area) {
    const n = contour.length, results = []; let run = [];
    const outside = contour.map(function (p) { return !ptInArea(p, area); });
    for (let i = 0; i < n; i++) {
      const j = (i + 1) % n;
      if (outside[i]) run.push(contour[i]);
      if (outside[i] && !outside[j]) { run.push(findCrossing(contour[j], contour[i], area)); if (run.length >= 2) results.push(run); run = []; }
      else if (!outside[i] && outside[j]) { run.push(findCrossing(contour[i], contour[j], area)); }
    }
    if (run.length >= 2) results.push(run);
    if (results.length >= 2 && outside[0]) { results[0] = results[results.length - 1].concat(results[0]); results.pop(); }
    return results;
  }
  function dedupeRunPoints(seg) {
    const out = [seg[0]];
    for (let i = 1; i < seg.length; i++) { const p = seg[i], q = out[out.length - 1]; if (Math.hypot(p[0] - q[0], p[1] - q[1]) > 0.01) out.push(p); }
    return out;
  }
  function polylineLength(pts) { let L = 0; for (let i = 1; i < pts.length; i++) L += Math.hypot(pts[i][0] - pts[i - 1][0], pts[i][1] - pts[i - 1][1]); return L; }

  // For letter i: occluderArea = union(hat, every later letter). Anything
  // of letter i's outline NOT covered by that area becomes a seam/score
  // line -- this is what makes the hat read as sitting in front of /
  // covering the first letter, exactly like a later letter covering an
  // earlier one. Any resulting open segment shorter than minArcLen is
  // dropped — these are the short stubs from boundary grazes that
  // visually appear to cross other score lines.
  function appendVisibleSeams(contours, occluderArea, seamSegs, minArcLen) {
    for (const contour of contours) {
      if (!occluderArea || occluderArea.length === 0) { seamSegs.push({ closed: true, pts: contour }); continue; }
      const fullyVisible = contour.every(function (pt) { return !ptInArea(pt, occluderArea); });
      if (fullyVisible) { seamSegs.push({ closed: true, pts: contour }); continue; }
      for (const seg of clipContourOutsideArea(contour, occluderArea)) {
        const clean = dedupeRunPoints(seg);
        if (clean.length >= 2 && polylineLength(clean) >= minArcLen) seamSegs.push({ closed: false, pts: clean });
      }
    }
  }

  function signedArea(poly) { let a = 0; for (let i = 0; i < poly.length; i++) { const p = poly[i], q = poly[(i + 1) % poly.length]; a += p[0] * q[1] - q[0] * p[1]; } return a / 2; }
  function centroid(poly) { let x = 0, y = 0; for (const p of poly) { x += p[0]; y += p[1]; } return [x / poly.length, y / poly.length]; }
  function findSolidIslands(polys) {
    const an = polys.map(function (c) { return { pts: c, absArea: Math.abs(signedArea(c)), cen: centroid(c) }; });
    return an.filter(function (a, i) {
      for (let j = 0; j < an.length; j++) { if (i === j) continue; if (an[j].absArea > a.absArea && ptInArea(a.cen, [an[j].pts])) return false; }
      return true;
    });
  }
  function countSolidIslands(polys) { return findSolidIslands(polys).length; }

  // Connects every disconnected solid island into a single piece by adding
  // a small rectangular bridge between each island and its nearest other
  // island, then re-unioning. This is deliberately surgical: unlike
  // dilating/eroding the whole shape (which can pinch tight, unrelated
  // curves elsewhere -- e.g. wherever two letters happen to pass close to
  // each other -- into stray sliver holes), it only ever adds geometry
  // exactly where two pieces are genuinely separate, and never touches any
  // other part of the design.
  function closestPointsBetween(c1, c2) {
    let best = Infinity, p1 = c1[0], p2 = c2[0];
    for (const a of c1) {
      for (const b of c2) {
        const d = (a[0] - b[0]) * (a[0] - b[0]) + (a[1] - b[1]) * (a[1] - b[1]);
        if (d < best) { best = d; p1 = a; p2 = b; }
      }
    }
    return { p1: p1, p2: p2, dist: Math.sqrt(best) };
  }
  function buildBridgeRect(p1, p2, width) {
    const dx = p2[0] - p1[0], dy = p2[1] - p1[1];
    const len = Math.hypot(dx, dy) || 1;
    const ux = dx / len, uy = dy / len;
    const nx = -uy * width / 2, ny = ux * width / 2;
    const ext = width * 0.5; // push each end past its contact point so the union overlap is robust, not a knife-edge touch
    const a = [p1[0] - ux * ext, p1[1] - uy * ext];
    const b = [p2[0] + ux * ext, p2[1] + uy * ext];
    const rect = [[a[0] + nx, a[1] + ny], [b[0] + nx, b[1] + ny], [b[0] - nx, b[1] - ny], [a[0] - nx, a[1] - ny]];
    return signedArea(rect) < 0 ? rect.reverse() : rect; // must match the same winding sign as solid letter contours, or the nonzero fill rule treats it as a hole and the union never actually connects
  }
  function buildConnectivityBridges(solidIslands, bridgeWidth) {
    if (solidIslands.length <= 1) return [];
    let groups = solidIslands.map(function (isl) { return [isl.pts]; });
    const bridges = [];
    while (groups.length > 1) {
      let bi = -1, bj = -1, bd = Infinity, bp1 = null, bp2 = null;
      for (let i = 0; i < groups.length; i++) {
        for (let j = i + 1; j < groups.length; j++) {
          for (const c1 of groups[i]) {
            for (const c2 of groups[j]) {
              const r = closestPointsBetween(c1, c2);
              if (r.dist < bd) { bd = r.dist; bi = i; bj = j; bp1 = r.p1; bp2 = r.p2; }
            }
          }
        }
      }
      bridges.push(buildBridgeRect(bp1, bp2, bridgeWidth));
      groups[bi] = groups[bi].concat(groups[bj]);
      groups.splice(bj, 1);
    }
    return bridges;
  }

  // The hanging ring: a solid annulus (outer circle minus inner circle)
  // built directly with the correct winding on each part, so feeding both
  // contours into the same union as the hat/letters Just Works the same
  // way a letter counter (the hole in an "O") already does -- the outer
  // circle adds material, the inner circle is read as a hole through it.
  function circlePoints(cx, cy, r, steps) {
    const pts = [];
    for (let i = 0; i < steps; i++) {
      const a = (i / steps) * Math.PI * 2;
      pts.push([cx + Math.cos(a) * r, cy + Math.sin(a) * r]);
    }
    return pts;
  }
  function makeAnnulusContours(cx, cy, rOuter, rInner) {
    let outerPts = circlePoints(cx, cy, rOuter, 72);
    let innerPts = circlePoints(cx, cy, Math.min(rInner, rOuter * 0.92), 56);
    if (signedArea(outerPts) < 0) outerPts = outerPts.reverse(); // must match solid winding
    if (signedArea(innerPts) > 0) innerPts = innerPts.reverse(); // must match hole winding (opposite of solid)
    return [outerPts, innerPts];
  }

  function rdp(points, eps) {
    if (points.length < 3) return points.slice();
    function perpDist(p, a, b) {
      const dx = b[0] - a[0], dy = b[1] - a[1]; const len = Math.hypot(dx, dy);
      if (len < 1e-9) return Math.hypot(p[0] - a[0], p[1] - a[1]);
      return Math.abs((p[0] - a[0]) * dy - (p[1] - a[1]) * dx) / len;
    }
    function rec(pts) {
      if (pts.length < 3) return pts;
      const a = pts[0], b = pts[pts.length - 1];
      let maxD = -1, idx = -1;
      for (let i = 1; i < pts.length - 1; i++) { const d = perpDist(pts[i], a, b); if (d > maxD) { maxD = d; idx = i; } }
      if (maxD > eps) { const left = rec(pts.slice(0, idx + 1)); const right = rec(pts.slice(idx)); return left.slice(0, -1).concat(right); }
      return [a, b];
    }
    return rec(points);
  }
  // Standard Catmull-Rom blends each point's tangent using both
  // neighbors, which assumes the curve is smooth everywhere. At a genuine
  // sharp corner (e.g. the right-angle bottom of a letter serif) that
  // blended tangent points somewhere between the two segments rather than
  // along either of them, and the resulting cubic bezier overshoots past
  // the corner -- a visible little spike/horn. CORNER_DOT_THRESHOLD flags
  // those points so their tangent instead points straight along the
  // adjacent segment (the same control-point formula that makes a cubic
  // bezier degenerate into an exact straight line), matching the corner
  // exactly with no overshoot. Smooth (non-corner) points are untouched.
  const CORNER_DOT_THRESHOLD = 0.55; // ~57 degrees of direction change or sharper counts as a hard corner
  function cornerDot(prev, cur, next) {
    const inX = cur[0] - prev[0], inY = cur[1] - prev[1];
    const outX = next[0] - cur[0], outY = next[1] - cur[1];
    const inLen = Math.hypot(inX, inY) || 1e-9, outLen = Math.hypot(outX, outY) || 1e-9;
    return (inX * outX + inY * outY) / (inLen * outLen);
  }
  function catmullRomD(pts, closed) {
    const n = pts.length;
    if (n < 2) return '';
    if (n === 2) return 'M' + pts[0][0].toFixed(2) + ',' + pts[0][1].toFixed(2) + ' L' + pts[1][0].toFixed(2) + ',' + pts[1][1].toFixed(2);
    const get = function (i) { return closed ? pts[(i + n) % n] : pts[Math.max(0, Math.min(n - 1, i))]; };
    const isCorner = new Array(n).fill(false);
    for (let i = 0; i < n; i++) {
      if (!closed && (i === 0 || i === n - 1)) continue; // open-path endpoints already get a one-sided tangent below
      isCorner[i] = cornerDot(get(i - 1), get(i), get(i + 1)) < CORNER_DOT_THRESHOLD;
    }
    let d = 'M' + pts[0][0].toFixed(2) + ',' + pts[0][1].toFixed(2) + ' ';
    const segCount = closed ? n : n - 1;
    for (let i = 0; i < segCount; i++) {
      const p0 = get(i - 1), p1 = get(i), p2 = get(i + 1), p3 = get(i + 2);
      const c1 = isCorner[i % n]
        ? [p1[0] + (p2[0] - p1[0]) / 3, p1[1] + (p2[1] - p1[1]) / 3]
        : [p1[0] + (p2[0] - p0[0]) / 6, p1[1] + (p2[1] - p0[1]) / 6];
      const c2 = isCorner[(i + 1) % n]
        ? [p2[0] - (p2[0] - p1[0]) / 3, p2[1] - (p2[1] - p1[1]) / 3]

        : [p2[0] - (p3[0] - p1[0]) / 6, p2[1] - (p3[1] - p1[1]) / 6];
      d += 'C' + c1[0].toFixed(2) + ',' + c1[1].toFixed(2) + ' ' + c2[0].toFixed(2) + ',' + c2[1].toFixed(2) + ' ' + p2[0].toFixed(2) + ',' + p2[1].toFixed(2) + ' ';
    }
    if (closed) d += 'Z';
    return d.trim();
  }
  function smoothSeam(pts, closed, eps) {
    let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
    for (const p of pts) { if (p[0] < minX) minX = p[0]; if (p[0] > maxX) maxX = p[0]; if (p[1] < minY) minY = p[1]; if (p[1] > maxY) maxY = p[1]; }
    const diag = Math.hypot(maxX - minX, maxY - minY);
    const safeEps = Math.min(eps, diag * 0.002);
    return catmullRomD(rdp(pts, safeEps), closed);
  }
  function transformedCmdsToD(cmds, scale, tx, ty) {
    let d = '';
    const tp = function (x, y) { return [(x * scale + tx).toFixed(2), (y * scale + ty).toFixed(2)]; };
    for (const c of cmds) {
      if (c.type === 'M') { const p = tp(c.x, c.y); d += 'M' + p[0] + ',' + p[1] + ' '; }
      else if (c.type === 'L') { const p = tp(c.x, c.y); d += 'L' + p[0] + ',' + p[1] + ' '; }
      else if (c.type === 'C') { const p1 = tp(c.x1, c.y1); const p2 = tp(c.x2, c.y2); const p = tp(c.x, c.y); d += 'C' + p1[0] + ',' + p1[1] + ' ' + p2[0] + ',' + p2[1] + ' ' + p[0] + ',' + p[1] + ' '; }
      else if (c.type === 'Z') d += 'Z ';
    }
    return d.trim();
  }

  /* ---------------------------------------------------------------------
   * 4. External libraries: ClipperLib, opentype.js, the Atma font itself.
   * ------------------------------------------------------------------- */
  function loadScript(src) {
    return new Promise(function (resolve, reject) {
      const s = document.createElement('script');
      s.src = src; s.onload = function () { resolve(); }; s.onerror = function () { reject(new Error('Failed to load ' + src)); };
      document.head.appendChild(s);
    });
  }

  const ATMA_TTF_URL = 'https://raw.githubusercontent.com/google/fonts/main/ofl/atma/Atma-Bold.ttf';
  const CLIPPERLIB_URL = 'https://cdn.jsdelivr.net/npm/clipper-lib@6.4.2/clipper.js';
  const OPENTYPE_URL = 'https://cdn.jsdelivr.net/npm/opentype.js@2.0.0/dist/opentype.min.js';

  let activeFont = null;
  let engineReady = false;

  function initEngine() {
    return Promise.all([loadScript(CLIPPERLIB_URL), loadScript(OPENTYPE_URL)])
      .then(function () { return fetch(ATMA_TTF_URL); })
      .then(function (resp) {
        if (!resp.ok) throw new Error('Could not fetch the Atma font (HTTP ' + resp.status + ')');
        return resp.arrayBuffer();
      })
      .then(function (buf) {
        activeFont = opentype.parse(buf);
        engineReady = true;
      });
  }

  /* ---------------------------------------------------------------------
   * 5. App state
   * ------------------------------------------------------------------- */
  const DEFAULTS = { name: 'Oliver', hatSizePct: 100, overlapPct: 60, holeMM: 6, nameOffsetX: 0, nameOffsetY: 0, widthVal: 5, widthUnit: 'in' };
  const state = Object.assign({}, DEFAULTS);

  const FONT_PX = 220; // fixed letter height
  function fontSizePx() { return FONT_PX; }
  const OVERLAP_K = 0.55;
  const HAT_WIDTH_RATIO = 1.298; // base 1.18, made 10% larger per user request
  // Expressed in hat-local units (multiplied by hatScale below), calibrated
  // against Oliver's hatScale (~1.1869) so the visible shift there is
  // unchanged at -40px/+25px -- but for a narrow first letter like "I" the
  // hat is much smaller (hatScale ~0.45) and a fixed pixel shift would throw
  // it way off proportionally; for a wide one like "W" (hatScale ~1.9) a
  // fixed shift undershoots and leaves a gap. Scaling with the hat itself
  // keeps the same relative nestling regardless of which letter starts the name.
  const HAT_X_SHIFT_LOCAL = -40 / 1.1869;
  const HAT_Y_SHIFT_LOCAL = 25 / 1.1869;
  const HAT_DIP_FRACTION = 0.30;
  const PREVIEW_PAD = 45;

  function safeName(n) {
    n = (n || '').replace(/[^A-Za-z \-'.]/g, '').slice(0, 14);
    return n.length ? n : 'Oliver';
  }

  const DOT_OVERLAP_FRACTION = 0.45; // fraction of the dot's own height that sinks into the stem
  function buildLetters(name, fpx, overlapPct) {
    // Cap the overlap reference width at fpx*0.5 so wide capitals (H, M, W)
    // don't produce proportionally more overlap than narrow lowercase letters.
    // Narrow letters (advance < fpx*0.5) use their own advance unchanged.
    const refWidth = fpx * 0.5;
    let cursorX = 0;
    const letters = [];
    for (let idx = 0; idx < name.length; idx++) {
      const ch = name[idx];
      const glyphPath = activeFont.getPath(ch, cursorX, 0, fpx);
      const rawContours = flattenCmds(glyphPath.commands, FLATTEN_TOL);
      let contours = rawContours, dotContour = null, bodyContours = rawContours;
      if ((ch === 'i' || ch === 'j') && rawContours.length > 1) {
        // The tittle is reliably the smallest-bbox contour; everything else is the stem.
        let dotIdx = 0, minArea = Infinity;
        rawContours.forEach(function (c, ci) {
          const b = bboxOfContours([c]);
          const a = b.width * b.height;
          if (a < minArea) { minArea = a; dotIdx = ci; }
        });
        const dot = rawContours[dotIdx];
        const body = rawContours.filter(function (_, ci) { return ci !== dotIdx; });
        const dotBox = bboxOfContours([dot]);
        const bodyBox = bboxOfContours(body);
        const gap = bodyBox.minY - dotBox.maxY; // positive = dot currently floats above the stem with a gap
        const shiftY = gap + dotBox.height * DOT_OVERLAP_FRACTION;
        dotContour = dot.map(function (p) { return [p[0], p[1] + shiftY]; });
        bodyContours = body;
        contours = body.concat([dotContour]);
      }
      const glyph = activeFont.charToGlyph(ch);
      const advance = glyph.advanceWidth * (fpx / activeFont.unitsPerEm);
      letters.push({ ch: ch, contours: contours, dotContour: dotContour, bodyContours: bodyContours, x: cursorX, advance: advance });
      const overlapAmt = Math.min(advance, refWidth) * OVERLAP_K * (overlapPct / 100);
      cursorX += (idx === name.length - 1) ? advance : advance - overlapAmt;
    }
    return letters;
  }
  function bboxOfContours(contours) {
    let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
    for (const c of contours) for (const p of c) { if (p[0] < minX) minX = p[0]; if (p[0] > maxX) maxX = p[0]; if (p[1] < minY) minY = p[1]; if (p[1] > maxY) maxY = p[1]; }
    return { minX: minX, minY: minY, maxX: maxX, maxY: maxY, width: maxX - minX, height: maxY - minY };
  }

  // The single source of geometric truth -- both the live preview and the
  // exported SVG are built from this, so they can never drift apart.
  function computeDesign() {
    const name = safeName(state.name);
    const fpx = fontSizePx();
    const letters = buildLetters(name, fpx, state.overlapPct);
    const firstBox = bboxOfContours(letters[0].contours);

    let hatScale = (firstBox.width * HAT_WIDTH_RATIO * (state.hatSizePct / 100)) / HAT_BBOX.width;
    if (letters[0].ch.toUpperCase() === 'I') hatScale *= 1.5; // "I" is unusually narrow
    const hatLocalCx = (HAT_BBOX.minX + HAT_BBOX.maxX) / 2;
    const hatLocalBottom = HAT_BBOX.maxY;
    const desiredCx = firstBox.minX + firstBox.width * 0.5;
    const desiredBottomY = firstBox.minY + firstBox.height * HAT_DIP_FRACTION;
    const hatTx = desiredCx - hatLocalCx * hatScale + HAT_X_SHIFT_LOCAL * hatScale;
    const hatTy = desiredBottomY - hatLocalBottom * hatScale + HAT_Y_SHIFT_LOCAL * hatScale;
    const hat = { scale: hatScale, tx: hatTx, ty: hatTy };

    const hatBaseContour = flattenCmds(HAT_BASE_CMDS, FLATTEN_TOL)[0];
    const hatContourAbs = [hatBaseContour.map(function (p) { return [p[0] * hatScale + hatTx, p[1] * hatScale + hatTy]; })];

    // Slide the name relative to the hat: the hat's position above was
    // anchored to the letters' natural (unshifted) layout, so translating
    // the letters now moves the name relative to a hat that stays put.
    if (state.nameOffsetX || state.nameOffsetY) {
      const ox = state.nameOffsetX, oy = state.nameOffsetY;
      const shiftContours = function (cs) { return cs.map(function (c) { return c.map(function (p) { return [p[0] + ox, p[1] + oy]; }); }); };
      letters.forEach(function (l) {
        l.contours = shiftContours(l.contours);
        l.bodyContours = shiftContours(l.bodyContours);
        if (l.dotContour) l.dotContour = l.dotContour.map(function (p) { return [p[0] + ox, p[1] + oy]; });
      });
    }

    // Preliminary bbox (hat + letters only) purely to convert the user's
    // mm hole size into design-space pixels before the ring -- which
    // itself becomes part of the unioned shape just below -- exists yet.
    // The ring is small relative to the whole piece, so sizing it off
    // this preliminary measurement rather than the true final bbox
    // (which can't be known until after the ring exists) makes no
    // visible difference in practice.
    const prelimPts = [];
    for (const l of letters) for (const c of l.contours) for (const p of c) prelimPts.push(p);
    for (const p of hatContourAbs[0]) prelimPts.push(p);
    const prelimWidth = Math.max.apply(null, prelimPts.map(function (p) { return p[0]; })) - Math.min.apply(null, prelimPts.map(function (p) { return p[0]; }));
    const physWidthMM = state.widthUnit === 'in' ? state.widthVal * 25.4 : state.widthVal;
    const prelimPxPerMM = prelimWidth / Math.max(1, physWidthMM);

    // Hanging ring: a separate tab of base material that mostly overhangs
    // above-left of the hat (touching it just enough to stay connected),
    // with a true hole through its own center -- not a hole drilled
    // straight into the hat's existing material.
    const ringInnerR = Math.max(1, (state.holeMM / 2) * prelimPxPerMM);
    const ringWallPx = Math.max(4, fpx * 0.07);
    const ringOuterR = ringInnerR + ringWallPx;
    const ringLocal = [HAT_BBOX.minX + HAT_BBOX.width * 0.11, HAT_BBOX.minY + HAT_BBOX.height * 0.10];
    const ringCenterAbs = [ringLocal[0] * hatScale + hatTx, ringLocal[1] * hatScale + hatTy];
    const ringContours = makeAnnulusContours(ringCenterAbs[0], ringCenterAbs[1], ringOuterR, ringInnerR);

    const rawOuter = clipperUnion([hatContourAbs, ringContours].concat(letters.map(function (l) { return l.contours; })));
    let outer = rawOuter;
    const islands = findSolidIslands(rawOuter);
    if (islands.length > 1) {
      const bridgeWidth = Math.max(5, fpx * 0.05);
      const bridges = buildConnectivityBridges(islands, bridgeWidth);
      outer = clipperUnion([rawOuter, bridges]);
    }

    const seamSegs = [];
    const minArcLen = fpx * 0.25; // ~55px — drops short stubs from boundary grazes
    for (let i = 0; i < letters.length; i++) {
      const after = i < letters.length - 1 ? letters.slice(i + 1).map(function (l) { return l.contours; }) : [];
      const baseOccluder = clipperUnion([hatContourAbs].concat(after));
      if (letters[i].dotContour) {
        const bodyOccluder = clipperUnion([hatContourAbs].concat(after).concat([[letters[i].dotContour]]));
        appendVisibleSeams(letters[i].bodyContours, bodyOccluder, seamSegs, minArcLen);
        appendVisibleSeams([letters[i].dotContour], baseOccluder, seamSegs, minArcLen);
      } else {
        appendVisibleSeams(letters[i].contours, baseOccluder, seamSegs, minArcLen);
      }
    }

    const allPts = [];
    for (const c of outer) for (const p of c) allPts.push(p);
    const bbox = {
      minX: Math.min.apply(null, allPts.map(function (p) { return p[0]; })),
      maxX: Math.max.apply(null, allPts.map(function (p) { return p[0]; })),
      minY: Math.min.apply(null, allPts.map(function (p) { return p[1]; })),
      maxY: Math.max.apply(null, allPts.map(function (p) { return p[1]; })),
    };
    bbox.width = bbox.maxX - bbox.minX; bbox.height = bbox.maxY - bbox.minY;

    return { name: name, fpx: fpx, letters: letters, hat: hat, outer: outer, seamSegs: seamSegs, bbox: bbox };
  }

  /* ---------------------------------------------------------------------
   * 6. Preview rendering
   * ------------------------------------------------------------------- */
  const SVG_NS = 'http://www.w3.org/2000/svg';
  function el(tag, attrs) {
    const e = document.createElementNS(SVG_NS, tag);
    for (const k in attrs) e.setAttribute(k, attrs[k]);
    return e;
  }

  function renderPreview() {
    const board = document.getElementById('boardSvg');
    if (!board) return;
    if (!engineReady) return;

    const design = computeDesign();
    const hat = design.hat, outer = design.outer, seamSegs = design.seamSegs, bbox = design.bbox;

    // Keep the preview roughly the same size regardless of name length.
    // Compute a reference width from a 6-letter word at the current font
    // size; the viewBox uses whichever is wider (the actual design or the
    // reference), so short names stay reasonably sized and long names are
    // allowed to expand.
    const refWidth = FONT_PX * 3.2; // approximate width of a 6-letter name
    const minVW = Math.max(bbox.width + PREVIEW_PAD * 2, refWidth);
    const vw = minVW;
    const vh = bbox.height + PREVIEW_PAD * 2;
    const vx = bbox.minX - PREVIEW_PAD - (vw - bbox.width - PREVIEW_PAD * 2) / 2;
    const vy = bbox.minY - PREVIEW_PAD;
    board.setAttribute('viewBox', vx + ' ' + vy + ' ' + vw + ' ' + vh);
    while (board.firstChild) board.removeChild(board.firstChild);

    const baseFillD = outer.map(function (c) { return smoothSeam(c, true, 0.6); }).join(' ');
    board.appendChild(el('path', { d: baseFillD, fill: '#c4905f', 'fill-rule': 'nonzero' }));

    const topG = el('g', {});
    for (const cmds of HAT_TOP_CMDS) {
      topG.appendChild(el('path', { d: transformedCmdsToD(cmds, hat.scale, hat.tx, hat.ty), fill: HAT_TOP_FILL, 'fill-rule': 'nonzero' }));
    }
    board.appendChild(topG);

    const seamD = seamSegs.map(function (s) { return smoothSeam(s.pts, s.closed, 0.6); }).join(' ');
    board.appendChild(el('path', { d: seamD, fill: 'none', stroke: '#7a4f2e', 'stroke-width': 2.4, 'stroke-linecap': 'round', 'stroke-linejoin': 'round' }));

    const hintEl = document.getElementById('widthHint');
    if (hintEl) {
      const physHeightVal = state.widthVal * (bbox.height / bbox.width);
      hintEl.textContent = 'Ornament \u2248 ' + state.widthVal.toFixed(state.widthUnit === 'in' ? 1 : 0) + ' \u00D7 ' + physHeightVal.toFixed(state.widthUnit === 'in' ? 1 : 0) + ' ' + state.widthUnit + ' when cut';
    }
  }

  /* ---------------------------------------------------------------------
   * 7. Export
   * ------------------------------------------------------------------- */
  function buildExportSVG() {
    const design = computeDesign();
    const letters = design.letters, hat = design.hat, outer = design.outer, seamSegs = design.seamSegs, bbox = design.bbox;

    const physWidthMM = state.widthUnit === 'in' ? state.widthVal * 25.4 : state.widthVal;
    const pxPerMM = bbox.width / Math.max(1, physWidthMM);

    const CUT = 'fill="none" stroke="#FF0000" stroke-width="1"';
    const SCORE = 'fill="none" stroke="#0000FF" stroke-width="1"';

    const PAD = Math.max(20, bbox.width * 0.04);
    const baseW = bbox.width + PAD * 2, baseH = bbox.height + PAD * 2;
    const baseOX = -bbox.minX + PAD, baseOY = -bbox.minY + PAD;

    const baseCutD = outer.map(function (c) { return smoothSeam(c, true, 0.6); }).join(' ');
    const seamD = seamSegs.map(function (s) { return smoothSeam(s.pts, s.closed, 0.6); }).join(' ');

    // Top layer: lay the 3 hat-top pieces out with the SAME transform as
    // they have in the design (so they line up with the base when glued),
    // just shifted into their own canvas region.
    const topPathsD = HAT_TOP_CMDS.map(function (cmds) { return transformedCmdsToD(cmds, hat.scale, hat.tx, hat.ty); });
    function topBBoxAll() {
      let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
      for (const cmds of HAT_TOP_CMDS) {
        const b = bboxOfCmds(cmds.map(function (c) {
          if (c.type === 'C') return { type: 'C', x1: c.x1 * hat.scale + hat.tx, y1: c.y1 * hat.scale + hat.ty, x2: c.x2 * hat.scale + hat.tx, y2: c.y2 * hat.scale + hat.ty, x: c.x * hat.scale + hat.tx, y: c.y * hat.scale + hat.ty };
          if (c.type === 'M' || c.type === 'L') return { type: c.type, x: c.x * hat.scale + hat.tx, y: c.y * hat.scale + hat.ty };
          return c;
        }));
        if (b.minX < minX) minX = b.minX; if (b.maxX > maxX) maxX = b.maxX;
        if (b.minY < minY) minY = b.minY; if (b.maxY > maxY) maxY = b.maxY;
      }
      return { minX: minX, minY: minY, maxX: maxX, maxY: maxY, width: maxX - minX, height: maxY - minY };
    }
    const topBBox = topBBoxAll();
    const topW = topBBox.width + PAD * 2, topH = topBBox.height + PAD * 2;
    const topOX = -topBBox.minX + PAD, topOY = -topBBox.minY + PAD;

    const LABEL_H = 30; // space for the label text below each layer
    const SEP = Math.max(30, bbox.width * 0.08);
    const totalW = baseW + SEP + topW;
    const totalH = Math.max(baseH, topH) + LABEL_H;

    const physTotalWmm = totalW / pxPerMM;
    const physTotalHmm = totalH / pxPerMM;
    const unitSuffix = state.widthUnit === 'in' ? 'in' : 'mm';
    const physTotalW = state.widthUnit === 'in' ? physTotalWmm / 25.4 : physTotalWmm;
    const physTotalH = state.widthUnit === 'in' ? physTotalHmm / 25.4 : physTotalHmm;

    const labelY = Math.max(baseH, topH) + LABEL_H * 0.65;
    const labelFontSize = Math.max(10, Math.min(16, totalW * 0.016));

    const parts = [];
    parts.push('<?xml version="1.0" encoding="UTF-8"?>');
    parts.push('<!-- RED = CUT   BLUE = SCORE (etch only, do not cut through) -->');
    parts.push('<svg xmlns="http://www.w3.org/2000/svg" width="' + physTotalW.toFixed(3) + unitSuffix + '" height="' + physTotalH.toFixed(3) + unitSuffix + '" viewBox="0 0 ' + totalW.toFixed(2) + ' ' + totalH.toFixed(2) + '">');

    parts.push('<g id="layer1-base" transform="translate(' + baseOX.toFixed(2) + ',' + baseOY.toFixed(2) + ')">');
    parts.push('<path d="' + baseCutD + '" ' + CUT + ' fill-rule="nonzero"/>');
    parts.push('<path d="' + seamD + '" ' + SCORE + '/>');
    parts.push('</g>');
    // Layer 1 label
    parts.push('<text x="' + (baseW / 2).toFixed(2) + '" y="' + labelY.toFixed(2) + '" text-anchor="middle" font-family="Inter, Arial, sans-serif" font-size="' + labelFontSize.toFixed(1) + '" fill="#333">');
    parts.push('Layer 1 (Base): <tspan fill="#FF0000" font-weight="700">Red=CUT</tspan> · <tspan fill="#0000FF" font-weight="700">Blue=Score</tspan>');
    parts.push('</text>');

    parts.push('<g id="layer2-top" transform="translate(' + (baseW + SEP + topOX).toFixed(2) + ',' + topOY.toFixed(2) + ')">');
    topPathsD.forEach(function (d) { parts.push('<path d="' + d + '" ' + CUT + ' fill-rule="nonzero"/>'); });
    parts.push('</g>');
    // Layer 2 label
    parts.push('<text x="' + (baseW + SEP + topW / 2).toFixed(2) + '" y="' + labelY.toFixed(2) + '" text-anchor="middle" font-family="Inter, Arial, sans-serif" font-size="' + labelFontSize.toFixed(1) + '" fill="#333">');
    parts.push('Layer 2 (Top): <tspan fill="#FF0000" font-weight="700">Red=CUT</tspan>');
    parts.push('</text>');

    parts.push('</svg>');
    return parts.join('\n');
  }

  function downloadSVG() {
    if (!engineReady) return;
    const svg = buildExportSVG();
    const blob = new Blob([svg], { type: 'image/svg+xml' });
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    const safe = safeName(state.name).replace(/[^A-Za-z0-9]/g, '') || 'ornament';
    a.download = 'santa-hat-' + safe.toLowerCase() + '.svg';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(a.href);
  }

  /* ---------------------------------------------------------------------
   * 8. UI wiring
   * ------------------------------------------------------------------- */
  let renderQueued = false;

  function scheduleRender() {
    if (renderQueued) return;
    renderQueued = true;
    requestAnimationFrame(function () { renderQueued = false; renderPreview(); });
  }

  function setVal(badgeId, text) { const e = document.getElementById(badgeId); if (e) e.textContent = text; }

  function wireUI() {
    const root = document.getElementById('plaque-app');

    const nameInput = document.getElementById('ni');
    nameInput.value = state.name;
    nameInput.addEventListener('input', function () {
      state.name = safeName(nameInput.value);
      scheduleRender();
    });

    const hatSizeSlider = document.getElementById('hatSizeSlider');
    hatSizeSlider.value = state.hatSizePct;
    hatSizeSlider.addEventListener('input', function () {
      state.hatSizePct = parseInt(hatSizeSlider.value, 10);
      setVal('hatSizeVal', state.hatSizePct + '%');
      scheduleRender();
    });

    const overlapSlider = document.getElementById('overlapSlider');
    overlapSlider.value = state.overlapPct;
    overlapSlider.addEventListener('input', function () {
      state.overlapPct = parseInt(overlapSlider.value, 10);
      setVal('overlapVal', state.overlapPct + '%');
      scheduleRender();
    });

    const posXSlider = document.getElementById('nameOffsetXSlider');
    posXSlider.value = state.nameOffsetX;
    posXSlider.addEventListener('input', function () {
      state.nameOffsetX = parseInt(posXSlider.value, 10);
      scheduleRender();
    });
    const posYSlider = document.getElementById('nameOffsetYSlider');
    posYSlider.value = state.nameOffsetY;
    posYSlider.addEventListener('input', function () {
      state.nameOffsetY = parseInt(posYSlider.value, 10);
      scheduleRender();
    });

    function wireStepper(minusId, plusId, valId, get, set, step, min, max, fmt) {
      document.getElementById(minusId).addEventListener('click', function () {
        set(Math.max(min, get() - step));
        document.getElementById(valId).textContent = fmt(get());
        scheduleRender();
      });
      document.getElementById(plusId).addEventListener('click', function () {
        set(Math.min(max, get() + step));
        document.getElementById(valId).textContent = fmt(get());
        scheduleRender();
      });
    }
    wireStepper('holeMinus', 'holePlus', 'holeVal',
      function () { return state.holeMM; }, function (v) { state.holeMM = v; },
      1, 2, 15, function (v) { return v + ' mm'; });

    const widthInput = document.getElementById('widthInput');
    widthInput.value = state.widthVal;
    widthInput.addEventListener('input', function () {
      const v = parseFloat(widthInput.value);
      if (!isNaN(v) && v > 0) { state.widthVal = v; scheduleRender(); }
    });

    const unitButtons = Array.prototype.slice.call(document.querySelectorAll('#unitToggle .unit-btn'));
    unitButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        const newUnit = btn.getAttribute('data-unit');
        if (newUnit === state.widthUnit) return;
        if (newUnit === 'mm') state.widthVal = Math.round(state.widthVal * 25.4 * 10) / 10;
        else state.widthVal = Math.round((state.widthVal / 25.4) * 100) / 100;
        state.widthUnit = newUnit;
        widthInput.value = state.widthVal;
        unitButtons.forEach(function (b) { b.classList.remove('on'); });
        btn.classList.add('on');
        scheduleRender();
      });
    });

    document.getElementById('downloadBtn').addEventListener('click', function () { downloadSVG(); });
    document.getElementById('resetBtn').addEventListener('click', resetAll);
  }

  function resetAll() {
    Object.assign(state, DEFAULTS);
    document.getElementById('ni').value = state.name;
    document.getElementById('hatSizeSlider').value = state.hatSizePct;
    setVal('hatSizeVal', state.hatSizePct + '%');
    document.getElementById('overlapSlider').value = state.overlapPct;
    setVal('overlapVal', state.overlapPct + '%');
    setVal('holeVal', state.holeMM + ' mm');
    document.getElementById('nameOffsetXSlider').value = state.nameOffsetX;
    document.getElementById('nameOffsetYSlider').value = state.nameOffsetY;
    document.getElementById('widthInput').value = state.widthVal;
    Array.prototype.slice.call(document.querySelectorAll('#unitToggle .unit-btn')).forEach(function (b) {
      b.classList.toggle('on', b.getAttribute('data-unit') === state.widthUnit);
    });
    scheduleRender();
  }

  /* ---------------------------------------------------------------------
   * 9. Init
   * ------------------------------------------------------------------- */
  function setLoadingState(msg) {
    const board = document.getElementById('boardSvg');
    if (!board) return;
    while (board.firstChild) board.removeChild(board.firstChild);
    board.setAttribute('viewBox', '0 0 640 200');
    const t = el('text', { x: 320, y: 105, 'text-anchor': 'middle', 'font-family': 'Inter, sans-serif', 'font-size': 16, fill: '#9aa3ad' });
    t.textContent = msg;
    board.appendChild(t);
  }

  document.addEventListener('DOMContentLoaded', function () {
    wireUI();
    setLoadingState('Loading font\u2026');
    const dlBtn = document.getElementById('downloadBtn');
    if (dlBtn) dlBtn.disabled = true;
    initEngine().then(function () {
      if (dlBtn) dlBtn.disabled = false;
      renderPreview();
    }).catch(function (err) {
      setLoadingState('Could not load the font/engine: ' + err.message);
    });
  });
})();

// ── Analytics tracking ───────────────────────────────────────
document.addEventListener('DOMContentLoaded', function () {
  // Track name entry (debounced 800ms, fires once per pause)
  const nameInput = document.querySelector('.santa-name-input');
  let nameTimeout;
  
  nameInput.addEventListener('input', function () {
    clearTimeout(nameTimeout);
    nameTimeout = setTimeout(() => {
      if (nameInput.value.trim() !== '') {
        gtag('event', 'santa_name_entered', {
          event_category: 'generator',
          generator_type: 'santa',
          event_label: 'santa_name_input_used',
          santa_name: nameInput.value.trim()
        });
      }
    }, 800);
  });
  
  // Track SVG downloads
  const downloadBtn = document.querySelector('.santa-download');
  downloadBtn.addEventListener('click', function () {
    gtag('event', 'santa_name_download', {
      event_category: 'generator',
      generator_type: 'santa',
      event_label: 'download_svg_button_clicked',
      santa_name: nameInput.value.trim()
    });
  });
});